import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './create-fire-insurance-brokerage.hooks';
import { FireInsuranceBrokerage } from '@models/brokerage';

@Component({
	selector: 'app-create-fire-insurance-brokerage',
	templateUrl: './create-fire-insurance-brokerage.component.html',
	standalone: false,
})
export class CreateFireInsuranceBrokerageComponent {
	testHooks = TestHooks;
	@Input() name;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Output() onCancel = new EventEmitter();
	@Output() onCreate = new EventEmitter();

	constructor(private matterDispatch: MatterDispatch) {}

	_onSubmit(fireInsuranceBrokerage: FireInsuranceBrokerage) {
		this.matterDispatch.CreateFireInsuranceBrokerage(
			this.matterId,
			fireInsuranceBrokerage,
		);
		this.onCreate.emit();
	}

	_onCancel() {
		this.onCancel.emit();
	}
}
